/**
 * DDS Loader wrapper - uses THREE.js DDSLoader for terrain tiles,
 * custom loader for everything else
 */

import * as THREE from 'three';
import { DDSLoader } from 'three/examples/jsm/loaders/DDSLoader.js';
import { OldDDS } from "./dds.old";
import { dataUrl } from '../util/path';

// Create a DDSLoader instance
let _threeLoader: DDSLoader | null = null;

function getThreeLoader() {
    if (!_threeLoader) {
        _threeLoader = new DDSLoader();
    }
    return _threeLoader;
}

export class DDS {
  /**
   * @param {String} path
   * @param {Function} callback
   * @return {THREE.CompressedTexture}
   */
  static load(path: any, callback: any, onError?: (err: any) => void) {
    // Check if this is a terrain tile texture
    const upperPath = path.toUpperCase();
    const isTerrainTile = upperPath.includes('TERRAIN') || upperPath.includes('TILES');

    if (isTerrainTile) {
        // Use THREE.js DDSLoader for terrain tiles
        const loader = getThreeLoader();
        const fullPath = dataUrl(path);

        // Create placeholder texture
        const texture = new (THREE.CompressedTexture as any)();
        texture.flipY = false;
        texture.generateMipmaps = false;
        texture.minFilter = THREE.LinearFilter;
        texture.magFilter = THREE.LinearFilter;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;

        // Load the file and parse it manually (like the working code)
        const fileLoader = new THREE.FileLoader();
        fileLoader.setResponseType('arraybuffer');
        fileLoader.load(
            fullPath,
            // onLoad
            (arrayBuffer: any) => {
                try {
                    // Parse DDS data
                    const texData = loader.parse(arrayBuffer, true);

                    // Update texture with parsed data (like the working code)
                    texture.image = { width: texData.width, height: texData.height };
                    texture.mipmaps = texData.mipmaps;
                    texture.format = texData.format as any;
                    texture.minFilter = texData.mipmapCount === 1 ? THREE.LinearFilter : THREE.LinearMipmapLinearFilter;
                    texture.magFilter = THREE.LinearFilter;
                    texture.needsUpdate = true;

                    if (callback) {
                        callback(texture);
                    }
                } catch (error) {
                    console.error('DDS.load parse error:', path, error);
                    if (callback) {
                        callback(null);
                    }
                    if (onError) onError(error);
                }
            },
            // onProgress
            undefined,
            // onError
            (err: any) => {
                console.error('DDS.load error:', path, err);
                if (callback) {
                    callback(null);
                }
                if (onError) onError(err);
            }
        );

        return texture;
    } else {
        // Use custom DDS loader for everything else
        return OldDDS.load(path, callback, onError);
    }
  }
}
